export default __webpack_public_path__ + "static/media/Group1236.041f6420.svg";